import {useEffect,useRef} from 'react';
import {toVideoTimeSec} from './syncTime';

export default function useReviewNoteTarget({active,target,teamId,mapId,videoId,src,videoData,loadedVideoIdentity,videoRef,pendingSeekRef,onOpen}){
 const applied=useRef(null);
 useEffect(()=>{
  if(!active||!target||target.videoId!==videoId||!src||!videoData||loadedVideoIdentity!==`${teamId}/${mapId}/${videoId}`)return;
  const key=JSON.stringify([teamId,mapId,videoId,target]);
  if(applied.current===key)return;
  applied.current=key;onOpen(false);
  const time=target.timeMode==='match'?toVideoTimeSec(target.timeSec,videoData.syncOffsetSec):target.timeSec;
  pendingSeekRef.current={time:Math.max(0,Number(time)||0),play:false};
  const element=videoRef.current;
  if(element?.readyState>=1){
   try{element.currentTime=pendingSeekRef.current.time;pendingSeekRef.current=null;}catch{/* Metadata/canplay retries the pending seek. */}
  }
 },[active,target,videoId,src,videoData,loadedVideoIdentity,teamId,mapId,videoRef,pendingSeekRef,onOpen]);
}
